<ng-template #settingsTemplate></ng-template>
<ng-template #contentTemplate>
    @if (path) {
    <img class="img" [src]="path" />
    }
</ng-template>
